/* Client state. The signed-in user and the open project come from the server now, so
   this holds only what the screens need in the moment. */

export const state = {
  user: null,
  googleEnabled: false,
  screen: "auth",          // auth | home | project
  currentProject: null,
  run: null,               // the finished run being viewed
  tab: "queries",
  onboarded: false,
};

/* Whether the walkthrough has been seen is a browser-local preference, not account data. */
const ONBOARDED_KEY = "oqc-onboarded";

export const prefs = {
  get onboarded() {
    try { return localStorage.getItem(ONBOARDED_KEY) === "1"; } catch { return state.onboarded; }
  },
  set onboarded(v) {
    state.onboarded = !!v;
    try { localStorage.setItem(ONBOARDED_KEY, v ? "1" : "0"); } catch { /* storage blocked */ }
  },
};
